// extracted by mini-css-extract-plugin
module.exports = {"floatingMenu":"floatingMenu_floatingMenu__24x5K","arrowContainer":"floatingMenu_arrowContainer__1KRFH","social":"floatingMenu_social__fCVns"};